import { SESSION_STORAGE_KEY } from '../constant/Constant';

class SessionStorageUtil {
    static get(key) {
        return JSON.parse(localStorage.getItem(key));
    }

    static set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static setConfig(data) {
        SessionStorageUtil.set(SESSION_STORAGE_KEY.CONFIG, data);
    }

    static getConfig() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG);
    }

    static setCode(data) {
        SessionStorageUtil.set(SESSION_STORAGE_KEY.CODE, data);
    }

    static getCode() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CODE);
    }

    static setCurrentSemester(data) {
        SessionStorageUtil.set(SESSION_STORAGE_KEY.CURRENT_SEMESTER, data);
    }

    static getCurrentSemester() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CURRENT_SEMESTER);
    }

    static getCurrentSemesterId() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CURRENT_SEMESTER).propValue;
    }

    static getCurrentSemesterNm() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CURRENT_SEMESTER).propNm;
    }

    static setAgreeAll(data) {
        return SessionStorageUtil.set(SESSION_STORAGE_KEY.AGREE_ALL, data);
    }

    static getAgreeAll() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.AGREE_ALL);
    }

    static setSessionValidTime(data) {
        return localStorage.setItem(SESSION_STORAGE_KEY.SESSION_VALID_TIME, data);
    }

    static getSessionValidTime() {
        return localStorage.getItem(SESSION_STORAGE_KEY.SESSION_VALID_TIME);
    }

    static setCaptcha(data) {
        return localStorage.setItem(SESSION_STORAGE_KEY.CAPTCHA, data);
    }

    static getCaptcha() {
        return localStorage.getItem(SESSION_STORAGE_KEY.CAPTCHA);
    }
}

export default SessionStorageUtil;
